import { IS_STAGING } from '@/lib/util/ProjectConfig';
import firebase from 'firebase';

const config = IS_STAGING ? {
  apiKey: "AIzaSyCAUGlYqReIAys2AFs_FpfGWi7umjfiXMU",
  authDomain: "kioskapp-staging.firebaseapp.com",
  databaseURL: "https://kioskapp-staging.firebaseio.com",
  projectId: "kioskapp-staging",
  storageBucket: "kioskapp-staging.appspot.com",
  messagingSenderId: "395126181221",
  appId: "1:395126181221:web:d3b23fac874c579a46a58c",
  measurementId: "G-3E0NXVRZ4S",
} : {
  apiKey: "AIzaSyCLRe0M2QFfncsCnjXD64vmPSbz1KuGQy8",
  authDomain: "kioskapp-f4a12.firebaseapp.com",
  databaseURL: "https://kioskapp-f4a12.firebaseio.com",
  projectId: "kioskapp-f4a12",
  storageBucket: "kioskapp-f4a12.appspot.com",
  messagingSenderId: "985279309715",
  appId: "1:985279309715:web:c6b0bfdae611d4834f6a66",
  measurementId: "G-EY1ZQ3GQYH",
};

export const firebaseApp = firebase.initializeApp(config);
export const analytics = firebaseApp.analytics();
